<div class="log-output-toolbar">
  <nz-input-group nzSearch [nzAddOnAfter]="suffixButton">
    <input type="text" nz-input placeholder="{{'workflow.log.search' | translateTA}}..." [(ngModel)]="searchValue" />
    <ng-template #suffixButton>
      <button nz-button nzType="primary">{{'workflow.log.search' | translateTA}}</button>
    </ng-template>
  </nz-input-group>
  <nz-divider nzType="vertical"></nz-divider>
  <button nz-button nzType="default" nzShape="circle" (click)="exportCSV()" nz-tooltip [nzTooltipTitle]="'export.excel' |translateTA">
    <nz-icon nzType="file-excel" nzTheme="twotone" nzTwotoneColor="green" />
  </button>
</div>

<nz-table
  [nzBordered]="true"
  [nzSize]="'small'"
  [nzData]="pagedEntries"
  [nzShowPagination]="false"
>
  <thead>
    <tr>
      <th nzShowSort [(nzSortOrder)]="sortOrder" (nzSortOrderChange)="sortKey='key'">{{'key'|arrayFilter}}</th>
      <th nzShowSort [(nzSortOrder)]="sortOrder" (nzSortOrderChange)="sortKey='value'">{{'value'|arrayFilter}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of pagedEntries;  trackBy: trackByKey">
      <td colspan="1">
        <div class="cell-with-copy">
          <div class="text-block" nz-tooltip [nzTooltipTitle]="item.key">{{ item.key }}</div>
          <button nz-button nzType="link" nzSize="small" class="copy-btn" (click)="copyText(item.key)">
            <i nz-icon nzType="copy"></i>
          </button>
        </div>
      </td>
      <td colspan="1" >
          <div class="cell-with-copy">
            <div class="text-block" >
              {{ prepareValue(item.value) }}
            </div> 
            <button nz-button nzType="link" nzSize="small" class="copy-btn"  (click)="copyText(item.value)">
              <i nz-icon nzType="copy"></i>
            </button>
             <!-- <button nz-button nzType="link" nzSize="small"
                  class="copy-btn"
                  (click)="copyText(item.value)">
                <span nz-icon nzType="copy"></span>
            </button>
             -->
            
              <!-- <button 
                  nz-button 
                      nzType="primary" 
                      (click)="onClick(item.key,item.value)"
                      [nz-tooltip]="label|translate">
                      <nz-icon [nzType]="'search'"></nz-icon>
                          {{'workflow.content.open'|translateTA}}
              </button> -->
            
           </div>
        <!-- <pre *ngIf="isPreContent(item.value)">{{ item.value }}</pre>
        <span *ngIf="!isPreContent(item.value)">{{ item.value }}</span> -->
      </td>
    </tr>
    <!-- <tr *ngFor="let item of pagedEntries" [nzExpand]="true">
      <td colspan="2">
        <pre *ngIf="isPreContent(item.value)">
          {{ item.value }}
        </pre>
        <span *ngIf="!isPreContent(item.value)">
          {{ item.value }}
        </span>
      </td> -->

  </tbody>
</nz-table>

<nz-pagination
  [(nzPageIndex)]="pageIndex"
  [(nzPageSize)]="pageSize"
  [nzTotal]="entries.length"
  [nzShowSizeChanger]="true"
  [nzPageSizeOptions]="[5,10,20,50]"
></nz-pagination>
